import { createRoot } from 'react-dom/client';

import { App } from './App';
import { LocaleProvider } from './i18n';
import { AnimeModeProvider } from './utils/AnimeModeContext';

import './index.css';

// Defer non-critical decorative CSS (animations, blur effects, theatrical reveal)
// to avoid blocking first contentful paint
void import('./animations.css');
void import('./anime-mode.css');

const element = document.getElementById('app');

if (element) {
	const root = createRoot(element);

	root.render(
		<LocaleProvider>
			<AnimeModeProvider>
				<App />
			</AnimeModeProvider>
		</LocaleProvider>,
	);
}
